@if (isLoading$ | async) {
  <app-page-loading></app-page-loading>
} @else {
  <div class="title">
    <app-bordered-dropdown-icon
      (click)="switchViewToManageProject()"
      [isClosed]="true"
      [useAsBackButton]="true"
    ></app-bordered-dropdown-icon>
    <span class="flex-1">Anticipated Cost</span>
    <span
      (click)="clearAllCosts()"
      class="clear-costs-button"
      [attr.disabled]="(isLoading$ | async) === true || !forecastModifications()?.length"
      >Clear All Costs</span
    >
  </div>

  <ng-scrollbar #scrollbar orientation="vertical" appearance="compact" class="std-scrollbar flex-1">
    <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
      <form name="forecastModsForm" role="form" #forecastModsForm="ngForm" class="h-full flex flex-col">
        @for (forecast_modification of forecastModifications(); track $index; let index = $index) {
          <app-general-sidebar-header [section]="true">
            <div class="flex" section>
              <div class="flex-1 uppercase text-base font-bold">Cost Group {{ index + 1 }}</div>
              <span
                (click)="removeBudgetLine(index)"
                class="delete-forecast-line icon-trash-x"
                [attr.disabled]="forecast_modification?.scos?.length > 0"
              ></span>
            </div>
          </app-general-sidebar-header>

          <div class="py-2 px-7 mx-0.5">
            <app-dropdown
              optionLabel="name"
              optionValue="id"
              [name]="'BudgetLine_' + index"
              label="Budget Line"
              placeholder="Budget Line"
              [options]="lineItemOptions()"
              [(ngModel)]="forecast_modification.id"
              (ngModelChange)="budgetLineChanged($event, index)"
              [disabledOptionIds]="disabledOptionIds()"
              [searchBar]="true"
              searchPlaceholder="Search Budget Lines..."
              required
            >
              <ng-template #selectedContent let-option>
                <div class="flex flex-col">
                  <div class="capitalize text-navy-900 text-medium">{{ option.name }}</div>
                  <div class="capitalize text-navy-900 font-normal">{{ option?.division }} {{ option?.cost_type }}</div>
                </div>
              </ng-template>
              <ng-template #optionContent let-option>
                <div
                  [ngClass]="{ 'disabled text-navy-500 pointer-events-none': disabledOptionIds().has(option.id) }"
                  class="flex flex-col text-navy-900"
                >
                  <div class="capitalize text-medium">{{ option.name }}</div>
                  <div class="capitalize font-normal">{{ option?.division }} {{ option?.cost_type }}</div>
                </div>
              </ng-template>
            </app-dropdown>

            @for (sco of forecast_modification?.scos; track sco.id; let scoIndex = $index) {
              <div class="flex-1 flex items-center gap-2">
                <div class="flex-1">
                  <app-floating-input
                    [(ngModel)]="sco.number"
                    [name]="'line_item_' + (index + 1) + '_sco_number_' + (scoIndex + 1)"
                    [label]="'SCO Description ' + (scoIndex + 1)"
                    [placeholder]="'SCO Description ' + (scoIndex + 1)"
                    [disabled]="true"
                    [maxLength]="255"
                    [tooltipText]="sco.title"
                  >
                  </app-floating-input>
                </div>
                <div class="flex-1 flex items-center gap-2">
                  <app-floating-input
                    class="flex-1"
                    [(ngModel)]="sco.value"
                    [name]="'line_item_' + (index + 1) + '_sco_value_' + (scoIndex + 1)"
                    [label]="'Dollar Amount ' + (scoIndex + 1)"
                    [placeholder]="'Dollar Amount ' + (scoIndex + 1)"
                    [disabled]="true"
                    type="money"
                  >
                  </app-floating-input>
                  <app-add-remove-buttons
                    class="mt-3"
                    [disabledRemove]="true"
                    (addItem)="insertItem(index)"
                  ></app-add-remove-buttons>
                </div>
              </div>
            }
            @for (item of forecast_modification.forecast_modifications; track $index; let itemIndex = $index) {
              <div class="flex gap-2.5 pr-2.5 items-center align-baseline">
                <div class="grid grid-cols-2 gap-2.5 w-full">
                  <app-floating-input
                    [name]="'note_' + index + '_' + itemIndex"
                    [(ngModel)]="item.note"
                    [label]="'Cost Description ' + ((forecast_modification?.scos?.length ?? 0) + itemIndex + 1)"
                    [placeholder]="'Cost Description ' + ((forecast_modification?.scos?.length ?? 0) + itemIndex + 1)"
                    required
                  ></app-floating-input>

                  <app-floating-input
                    [name]="'value_' + index + '_' + itemIndex"
                    [(ngModel)]="item.value"
                    label="Dollar Amount"
                    placeholder="Dollar Amount"
                    type="money"
                    [required]="true"
                  ></app-floating-input>
                </div>
                <app-add-remove-buttons
                  class="mt-3"
                  [disabledRemove]="forecast_modification?.forecast_modifications.length === 1"
                  (removeItem)="deleteItem(index, itemIndex)"
                  (addItem)="insertItem(index, itemIndex)"
                ></app-add-remove-buttons>
              </div>
            }
          </div>
        } @empty {
          <div class="flex flex-col items-center justify-center h-full py-2">
            <span class="text-navy-600 text-size_sm">No anticipated costs</span>
          </div>
        }
        <div class="px-7 mx-0.5">
          <app-simple-button
            size="large"
            [wrapperClass]="{
              'w-full bg-color-white border rounded border-solid border-blue-700 text-blue-700 text-sm font-semibold': true,
            }"
            class="flex mt-2.5"
            (click)="addBudgetLine()"
          >
            Add Cost Group
          </app-simple-button>
        </div>
      </form>
    </div>
  </ng-scrollbar>

  <div class="flex items-center py-4 px-8 gap-10">
    <div class="text-navy-700 font-bold flex justify-between w-full">
      <span> Total </span>
      <span [ngClass]="{ negative: total() < 0 }">{{ total() | money: 'positiveComa' }}</span>
    </div>
    <app-simple-button buttonStyle="color_accent_filled" class="flex ml-auto" (click)="save()" [disabled]="isSending()">
      Save
    </app-simple-button>
  </div>
}
